import { Alert, Modal, Spinner, Table, Form, Button } from "react-bootstrap";
import { useState } from 'react';
import { getAuthToken } from "../../utils/AuthUtils";
import { BENCHMARK_CODE_MAP } from "../../Constants";
import { API } from 'aws-amplify';
import "./styles.scss";

const BenchmarkPreviewModal = ({ show, onClose, selectedSurveyRows, selectedSurveyTemplateId, surveyYear }) => {
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [showError, setShowError] = useState(false);
    const [data, setData] = useState({});
    const [selectedBenchmark, setSelectedBenchmark] = useState("");
    const [selectedReportingLevel, setSelectedReportingLevel] = useState(0);
    const [showDataTable, setShowDataTable] = useState(false);

    const fetchBenchmarkTDCPreviewValues = async () => {

        if (!selectedBenchmark) {
            setErrorMessage("Please select a benchmark");
            setShowError(true);
            return;
        }
        
        setLoading(true);
        setShowDataTable(false);
        setShowError(false);
        const queryStringParameters = {
            companyIds: extractCompanyIds(selectedSurveyRows),
            templateId: selectedSurveyTemplateId,
            surveyYear: surveyYear,
            benchmark: selectedBenchmark,
            reportingLevel: selectedReportingLevel
        }
        const authToken = await getAuthToken();
        API.get("AnnualCompensations", "/survey-preview/benchmark", {
            headers: {
                'Token': authToken
            },
            queryStringParameters
        }).then((response) => {
            setLoading(false);
            setData(response);
            setShowDataTable(true);
        }).catch((error) => {
            console.log(error);
            setLoading(false);
            if (error !== undefined && error.response !== undefined &&
                error.response.data !== undefined && error.response.data.message !== undefined) {
                setErrorMessage(error.response.data.message);
                setShowError(true);
            }
        });
    }

    const extractCompanyIds = (selectedSurveyRows) => {
        const companyIds = [];
        for (const row of selectedSurveyRows) {
            const elements = row.split("#");
            companyIds.push(elements[2]);
        }
        return companyIds.join(",");
    }

    const dataTable = (
        <div>
            <Table striped bordered hover size="sm">
                <thead className="table-light">
                    <tr>
                        <th style={{ width: '20%' }} className="fw-semibold small text-uppercase py-2">Count</th>
                        <th style={{ width: '20%' }} className="fw-semibold small text-uppercase py-2">Mean ($)</th>
                        <th style={{ width: '20%' }} className="fw-semibold small text-uppercase py-2">Median ($)</th>
                        <th style={{ width: '20%' }} className="fw-semibold small text-uppercase py-2">25th %tile ($)</th>
                        <th style={{ width: '20%' }} className="fw-semibold small text-uppercase py-2">75th %tile ($)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr key={"benchmark-data"}>
                        <td>{data.count}</td>
                        <td>{Math.round(data.mean).toLocaleString()}</td>
                        <td>{Math.round(data.median).toLocaleString()}</td>
                        <td>{Math.round(data.percentile25).toLocaleString()}</td>
                        <td>{Math.round(data.percentile75).toLocaleString()}</td>
                    </tr>
                </tbody>
            </Table>
        </div>
    )

    const handleClose = () => {
        setErrorMessage("");
        setShowError(false);
        setSelectedBenchmark("");
        setSelectedReportingLevel(0);
        setShowDataTable(false);
        setData({});
        onClose();
    }

    return (
        <div className="benchmark-preview-container">
            <Modal show={show} onHide={handleClose} size="lg" dialogClassName="dashboard-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Total Direct Compensation Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3" controlId="benchmarkSelect">
                            <Form.Label>Benchmark</Form.Label>
                            <Form.Select value={selectedBenchmark} onChange={(e) => setSelectedBenchmark(e.target.value)}>
                                <option value="">Select Benchmark</option>
                                {Object.keys(BENCHMARK_CODE_MAP).map((key) => (
                                    <option key={key} value={key}>{BENCHMARK_CODE_MAP[key]}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="reportingLevelSelect">
                            <Form.Label>Reporting Level</Form.Label>
                            <Form.Select value={selectedReportingLevel} onChange={(e) => setSelectedReportingLevel(e.target.value)}>
                                <option value={0}>All Reporting Levels</option>
                                <option value={2}>Reporting Level 2</option>
                                <option value={3}>Reporting Level 3</option>
                                <option value={4}>Reporting Level 4 and Below</option>
                            </Form.Select>
                        </Form.Group>
                    </Form>
                    {showError && <Alert variant="danger">{errorMessage}</Alert>}
                    {loading ? <Spinner animation="border" /> : null}
                    {showDataTable ? dataTable : null}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={fetchBenchmarkTDCPreviewValues} style={{ "width": "20%" }} disabled={loading || !selectedBenchmark}>
                        Search
                    </Button>
                    <Button variant="secondary" style={{ "width": "20%" }} onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default BenchmarkPreviewModal;
